require('./lang-selector.less');
require('./lang-selector-template.html');

angular.module('bbl.directives')

// fixed position dropdown
.directive('langSelector', ['$translate', '$rootScope', function($translate, $rootScope) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'lang-selector-template.html',

    link: function($scope, $el, atts) {
      $scope.selected = $translate.use();
      $scope.select = function(lang) {
        $translate.use(lang);
        $scope.selected = lang;
      };

      $rootScope.$on('$translateChangeEnd', function(_, ev) {
        $scope.selected = ev.language;
      });
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/lang-selector/index.js
 ** module id = 183
 ** module chunks = 0
 **/